import React, { useEffect } from 'react';
import {Outlet} from 'react-router-dom';
import {ConfigProvider, message, Spin} from 'antd';
import {NoticeType} from "antd/es/message/interface";
import {useStore} from "zustand";
import locale from 'antd/locale/ko_KR';
import {useMessageStore} from "./stores/messageStore";
import userAPI from "./api/userAPI";
import {useAuthStore} from "./stores/authStore";
import {RoleType} from "./types/Role";
import {getIsDev, getIsLocal} from "./util/host";
import {useAppStore} from "./stores/appStore";

const App: React.FC = () => {
  const { isShow, type, content } = useMessageStore();
  const { setRoles, isLoggedIn } = useStore(useAuthStore);
  const { shouldShowSpinner } = useAppStore();

  const [messageApi, contextHolder] = message.useMessage();

  const openMessage = (type: NoticeType, content: string) => messageApi.open({
    type,
    content,
  });

  const checkHasSystemRole = async () => await userAPI.getRoleAPI();

  useEffect(() => {
    const isLocal = getIsLocal();
    const isDev = getIsDev();
    if (isLocal) {
      document.title = '배차방 운영(로컬)';
    }
    if (isDev) {
      document.title = '배차방 운영(개발)';
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      checkHasSystemRole().then((res) => {
        setRoles(res as RoleType[]);
      });
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (isShow) {
      openMessage(type, content).then();
      // 초기화
      useMessageStore.setState({
        isShow: false,
        type: 'info',
        content: '',
      });
    }
  }, [isShow, type, content]);

  return (
    <ConfigProvider
      locale={locale}
      theme={{
        components: {
          Layout: {
            headerBg: '#fff',
            headerColor: '#000',
            headerHeight: '64px',
            headerPadding: '0 24px',
          },
        },
      }}
    >
      {shouldShowSpinner && (
        <div style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.2)',
          zIndex: 2000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <Spin size="large" />
          <div style={{ marginTop: 8, color: '#fff' }}>처리 중입니다...</div>
        </div>
      )}
      {contextHolder}
      <Outlet />
    </ConfigProvider>
  );
};

export default App;
